export type DepartmentAvailabilityStatus = 'Online' | 'Busy' | 'Offline'

export type DepartmentAvailabilityStatusResponse = {
  status: DepartmentAvailabilityStatus
  additionalPrepMinutes?: number | null
  expiresAtUtc?: string | null
}

export type SetDepartmentAvailabilityRequest = {
  status: DepartmentAvailabilityStatus
  additionalPrepMinutes?: number | null
  durationMinutes?: number | null
}

/** Prep-time stepper: 20-minute increments, default 20. */
export const PREP_TIME_STEP_MINUTES = 20
export const DEFAULT_PREP_TIME_MINUTES = 20
